// i18n bootstrap. OTA-safe — no native plugins added.
//
// Policy: the app ALWAYS boots in English. The only way to switch to another
// language is via Account → Language. We deliberately do NOT auto-detect the
// browser or iOS preferred language — users have been confused by silent
// switches. Stored override (`roava.locale` = "en" | "mn") wins on next boot.

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enCommon from "@/locales/en/common.json";
import mnCommon from "@/locales/mn/common.json";

export type AppLocale = "en" | "mn";
export const SUPPORTED_LOCALES: AppLocale[] = ["en", "mn"];
const STORAGE_KEY = "roava.locale";

function readStoredSync(): AppLocale | null {
  try {
    const v = typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
    if (v === "en" || v === "mn") return v;
  } catch { /* ignore */ }
  return null;
}

const initial: AppLocale = readStoredSync() ?? "en";

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon },
      mn: { common: mnCommon },
    },
    lng: initial,
    fallbackLng: "en",
    defaultNS: "common",
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export function getStoredLocalePreference(): AppLocale {
  return readStoredSync() ?? "en";
}

export async function setLocalePreference(pref: AppLocale): Promise<void> {
  try {
    if (typeof localStorage !== "undefined") localStorage.setItem(STORAGE_KEY, pref);
  } catch { /* ignore */ }
  if (pref !== i18n.language) await i18n.changeLanguage(pref);
}

export { i18n };
export default i18n;
